import Vue from 'vue'
Vue.prototype.imgUrl = 'http://58.243.0.26:81/'


// WEBPACK FOOTER //
// ./src/assets/js/common.js